import { FileTextFilled, FormOutlined } from "@ant-design/icons";

export const requirementTypeMapping = (color: string) => {
  return {
    form: {
      icon: <FormOutlined style={{ color }} />,
      title: "Formulario",
    },
    file: {
      icon: <FileTextFilled style={{ color }} />,
      title: "Archivo",
    },
  };
};
